import { useInstance as useApiInstance } from "@/api/instance";
import { instanceSchema } from "@/schemas";

/** Get the Instance for the current backend. */
export const useInstance = () => {
  const { data } = useApiInstance();
  return data || instanceSchema.parse({});
};
